import React from "react";
import Popover from "../../../../../components/popover/Popover";
import { IconVariant } from "../../../../../components/theme/icon/Icon";

export default function ChannelModeHelp({
    buttonClassName,
    iconSize,
    iconVariant,
}: {
    buttonClassName?: string;
    iconSize?: "xs" | "sm" | "md" | "lg";
    iconVariant?: IconVariant;
}) {
    return (
        <Popover iconVariant={iconVariant} buttonClassName={buttonClassName} iconSize={iconSize} title="Channel Menu Help">
            <ul>
                <li>
                    Threaded mode will create a new ticket for each message in the main channel.
                </li>
                <li>
                    Manual mode will only create tickets when triggered by other means such as emoji actions.
                </li>
            </ul>
        </Popover>
    );
}

ChannelModeHelp.defaultProps = {
    buttonClassName: "",
    iconSize: undefined,
    iconVariant: undefined,
};
